import React from 'react'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'
import { MEDIA_BASE_URL } from '../../../api'
import '../productPages.css'

function Mushroom() {
    const BASE = `${MEDIA_BASE_URL}/machines-images/Cold Stores/mushrooms`
    const images = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33].map(n => `${BASE}/Slide${n}.JPG`)
    return (
        <div>
            <Navbar />
            <div className='pp-gallery'>
                {images.map((image, index) => (<img key={index} src={image} alt={`Slide ${index + 1}`} loading='lazy' />))}
            </div>
            <Footer />
        </div>
    )
}

export default Mushroom
